import { createEvent, restore, sample } from 'effector'
import { fx, path } from 'src/libs'
import { $params, toPath } from '../../../../../features/router'
import { RequestError } from '../../../../../shared/errorResponse'
import { Offer } from '../list/types'

export const offerMounted = createEvent()

export const setOfferForm = createEvent<Omit<Offer, 'id'>>()

export const setError = createEvent<RequestError>()

export const submitUpdateOffer = createEvent<Omit<Offer, 'id' | 'offerLink'>>()

export const $offer = restore(setOfferForm, {
  title: '',
  isVisible: true,
  offerLink: [],
})

export const getOffer = fx<void, Offer>({
  method: 'GET',
  url: '/partner/material/offer/{offerID}',
})

export const updateOffer = fx<Omit<Offer, 'id' | 'offerLink'>, void>({
  method: 'PUT',
  url: '/partner/material/offer/{offerID}',
})

export const $error = restore(setError, {
  message: '',
  code: 0,
})

sample({
  clock: offerMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.offerID
    }
    return {
      url: `/partner/material/offer/${id}`,
    }
  },
  target: getOffer,
})

sample({
  clock: submitUpdateOffer,
  source: $params,
  fn: (params, offer) => {
    let id
    if (params) {
      id = params.offerID
    }

    return {
      url: `/partner/material/offer/${id}`,
      body: { ...offer },
    }
  },
  target: updateOffer,
})

sample({
  clock: [getOffer.doneData],
  fn: (doneData) => doneData.body,
  target: [setOfferForm],
})

sample({
  clock: updateOffer.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setError],
})

sample({
  clock: [updateOffer.doneData],
  target: toPath.prepend(path.ib.ad.offers.entry),
})
